<template>
  <div style="padding: 0rem 2.5rem;">
    <div class="title">
        <h4>
          Lista de Spare Parts
        </h4>
    </div>

    <div v-if="configInputs != 1" class="">
      <div>
        <div class="">
          <div class="row-1">
            <div class="one">
              <label class=""> Descrição: </label>
              <input
                v-model="v$.desc.$model"
                type="text"
                :class="['field', { error: v$.desc.$error }]"
                placeholder="Informe a descrição"
              />
              <div class="errormessage" v-if="v$.desc.$error">
                O campo Descrição deve conter no mínimo 3 caracteres.
              </div>
            </div>
            <div class="one">
              <label class=""> Quantidade: </label>
              <input
                v-model="v$.quantidade.$model"
                v-maska="['##', '']"
                :class="['field', { error: v$.quantidade.$error }]"
                placeholder="Informe a quantidade"
              />
              <div class="text-red" v-if="v$.quantidade.$error">
                O campo quantidade deve conter no mínimo 1 valor numerico.
              </div>
            </div>
            <div class="one">
              <label class=""> Observação: </label>
              <input
                v-model="v$.observacao.$model"
                type="text"
                :class="['field', { error: v$.observacao.$error }]"
                placeholder="Informe sua observação"
              />
              <div class="text-red" v-if="v$.observacao.$error">
                O campo observação deve conter no mínimo 3 caracteres.
              </div>
            </div>
            <div class="one">
              <label style="color: #cccccc00;"> Imagem</label>
              <div style="display: flex; gap: 1rem;">
                <label :class="['buttonaddimage', { 'image-added': file !== '' }]" for="fotoSpareParts">
                  <p v-if="file==''">Adicionar Imagem</p>
                  <p v-if="file!==''" style="font-size: 0.7rem;">Imagem Adicinada ✓</p>
                </label>
                <input
                  type="file"
                  accept="image/*"
                  @change="addFiles"
                  id="fotoSpareParts"
                  name="fotoSpareParts"
                  hidden
                />
                 <div class="btn-produto">
                <button
                  @click="addInList"
                  type="button"
                  class="btn-button-produto"
                >
                </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cards-container">
      <label v-if="title"> Listagem de Produtos Relacionados </label>
      <div class="card" v-for="l in list_lsp" :key="l.id">
        <div class="sectioncard">
          <button type="button" @click="clickPreview(l.preview)">
              <div class="image-wrapper">
                <img :src="l.preview" alt="preview" />
              </div>
          </button>
        </div>
        <div class="sectioncard" style="width: 100%;">
          <div>
            <p><strong>Quantidade:</strong> {{ l.quantidade }}</p>
            <p><strong>Descrição:</strong> {{ l.desc }}</p>
            <p><strong>Observação:</strong> {{ l.observacao }}</p>
          </div>
          <div v-if="configInputs != 1" >
            <div class="btnDelete">
              <button type="button" @click="clickDeleteLSP(l.id)">
              </button>
            </div>
          </div>
        </div>
    </div>
</div>

  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, minValue } from "@vuelidate/validators";
export default {
  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      list_lsp: [],
      count: 0,
      id: "",
      desc: "",
      quantidade: "",
      observacao: "",
      preview: "",
      file: "",
      title: false,
      ListLSP: ""
    };
  },

  watch: {
    list_lsp: {
      deep: true,
      immediate: true,
      handler(newValue, OldValue) {
        this.$store.commit("MutationImagesLSP", newValue);
      },
    },
  },

  validations() {
    return {
      desc: {
        minLength: minLength(3),
      },
      quantidade: {
        minValueValue: minValue(1),
      },
      observacao: {
        minLength: minLength(3),
      },
    };
  },

  methods: {
    addFiles(event) {
      const input = event.target;

      if (input.files && input.files[0]) {
        const file = input.files[0];

        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c", 
          });
          input.value = ""; 
          return;
        }

        this.file = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        reader.readAsDataURL(file);
      }

    },

    addInList() {
      if (
        this.v$.desc.$invalid == true ||
        this.v$.quantidade.$invalid == true ||
        this.v$.observacao.$invalid == true ||
        this.v$.desc.$model == "" ||
        this.v$.quantidade.$model == "" ||
        this.file == ""
      ) {
        const Toast = this.$swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "error",
          title: "Item não adicionado.",
          text: "Verifique os dados inputados !",
        });
      } else {
        this.count += 1;
        this.id = this.count;
        const data = {
          id: this.id,
          desc: this.desc,
          quantidade: this.quantidade,
          observacao: this.observacao,
          preview: this.preview,
          file: this.file,
        };

        this.desc ="";
        this.observacao="";
        this.quantidade="";
        this.file="";
        this.list_lsp.push(data);
        this.$store.commit("MutationImagesLSP", this.list_lsp);
        this.title=true;
      }
    },

    clickPreview(base64) {
      this.$swal.fire({
        title: 'Visualização da Imagem',
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: 'Baixar',
          showCloseButton: true,
          background: "#fff",
          customClass: {
            popup: 'preview-modal-popup',
            image: 'preview-modal-image',
            confirmButton: 'preview-modal-button'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement('a');
            link.href = base64;
            link.download = 'imagem.jpg'; 
            link.click();
          }
      });
      //  this.$swal('Hello Vue world!!!');
    },

    clickDeleteLSP(id) {
      let index = this.list_lsp.findIndex((element) => element.id === id);

      this.list_lsp.splice(index, 1);

      this.$store.commit("MutationImagesLSP", this.list_lsp);
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.ListSpareParts) {
        dataQuery.ListSpareParts.map((element) => {
          this.list_lsp.push({
            id: element.ID,
            desc: element.DESCRIPTION,
            quantidade: element.QUANTIDADE,
            observacao: element.OBSERVACAO,
            preview: `${this.$store.state.ImgURL}` + `${element.PATH_IMG}`,
            file: "",
          });
        });
      }
    },
  },
};
</script>
<style scoped>

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.swal2-image.original-size-image {
  max-width: 90vw;
  max-height: 80vh;
  width: auto;
  height: auto;
  border-radius: 1rem;
}

.image-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 0.5rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
}

.image-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-added {
  background-color: #28a745 !important; 
  border: 1px solid #218838;
}

.image-added p {
  color: white;
  font-weight: bold;
}

.title {
  margin: 0.5rem 0rem;
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;
}

.cards-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.card {
  display: flex;

}

.card p {
  margin: 0.2rem 0;
  font-size: 0.9rem;
  font-family: 'Poppins', sans-serif;
}

.card img {
  border-radius: 6px;
  border: 1px solid #ccc;
}

.row-1{
  gap: 1rem;
  display: flex;
  color: var(--font_color);
  margin-bottom: 0.5rem;
  align-items: top;
  flex-wrap: wrap;
  opacity: 0;
  animation: fadeIn 1s ease forwards!important;

}

label {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
}

.field {
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 16rem!important;
  padding: 1rem;
  color: var(--font_color);
  
}

.field_select {
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 13rem!important;
  color: var(--font_color);
  
}

.field:hover {
  border: 1px solid var(--input_hover)!important;
  transition: border-color 0.5s ease;
}

.field:focus {
  border: 1px solid var(--green)!important;
}

.field::placeholder{
  color: rgb(65, 62, 62)!important;
}

.section-field {
  display: flex;
  flex-direction: column;
}

.error {
  border-radius: 10px!important;
  height:2.5rem!important;
  width: 13rem!important;
  padding: 1rem;
  color: var(--font_color);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: red;
  font-size: 0.8rem;
  width: 13rem!important;
  text-align: center;
}

.one {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.buttonaddimage {
  display: flex;
  align-items: center;
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  width: 10rem!important;
  padding: 1rem;
  color: var(--font_color);
  background-color: #a5a4a4;
  cursor: pointer;
}

.buttonaddimage p{
  color: white;
  font-family: 'Poppins', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
}



.btn-button-produto {
  height: 2.3rem!important;
  width: 4rem!important;
  cursor: pointer;
  margin: 0 auto;
  background-image: url(../../../../../static/icons/+.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 30%;
  background-color: var(--green);
  border-radius: 0.5rem;

}


.btn-produto {
  display: flex;
  align-items: center;
  align-items: center;
  height:2.5rem!important;
  animation: pulse 0.5s ease-in-out 3;
}

.btn-button-produto:hover {
  background-color: var(--green_hover);
}

.btn-button-produto:focus {
  background-color: var(--green_focus);
}

.sectioncard {
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
}

.sectioncard div{
}

.btnDelete {
cursor: pointer;
background-image: url('../../../../../static/icons/trash.svg')!important;
background-repeat: no-repeat;
background-position: center;
width: 2rem;
}

.btnDelete button{
width: 2rem!important;
height: 2rem!important;

background-color: #d9d9d900;
}

.errormessage {
  font-size: 0.8rem;
  color: red;
  width: 13rem;
  text-align: center;
}

@media (max-width: 1266px){
  .row-1{
    justify-content: center;
  }
.one {
    width: 100%;
    max-width: 20rem;
  }
  
  .field,
  .field_select,
  .error,
  .buttonaddimage {
    width: 100% !important;
    max-width: 20rem;
  }

  .btn-produto {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .card {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .sectioncard {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .btnDelete {
    margin-top: 0.5rem;
  }

  .sectioncard div {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .field,
  .field_select,
  .error,
  .buttonaddimage {
    width: 100% !important;
    max-width: 100%;
  }

  .image-wrapper {
    width: 100px;
    height: 100px;
  }
}
</style>
